import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

export const getSimNetworkServices = async (token, simId) => {
    log("welcome in getSimNetworkServices from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.get(BASE_URL + '/home/get_sim_network_services_api', {
            headers: getHeaders(token),
            params: { sim_id: simId }
        })
        return result.data
    } catch (err) {
        log("Error in getSimNetworkServices", err)
        return { error: true, message: "Error loading network services" }
    }
}

export const toggleNetworkService = async (token, simId, productCodeName) => {
    log("welcome in toggleNetworkService from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/toggle_network_service_api', {
            sim_id: simId,
            product_code_name: productCodeName
        }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in toggleNetworkService", err)
        return { error: true, message: "Error toggling network service" }
    }
}

export const changeRoamingApi = async (token, simId, selectedZoneId) => {
    log("welcome in changeRoamingApi from web")
    if (!token) return { error: true, message: "No token provided" }
    try {
        const result = await axios.post(BASE_URL + '/home/change_roaming_api', {
            sim_id: simId,
            selected_zone_id: selectedZoneId
        }, { headers: getHeaders(token) })
        return result.data
    } catch (err) {
        log("Error in changeRoamingApi", err)
        return { error: true, message: "Error changing roaming" }
    }
}
